import React, { FC } from 'react';

interface HelpCircleProps {
  id?: string;
  classes?: string | undefined;
  color?: string | undefined;
  height?: number | undefined;
  width?: number | undefined;
  strokeWidth?: number | undefined;
}

const HelpCircle: FC<HelpCircleProps> = ({
  id,
  classes = '',
  color = 'indigo',
  height = 24,
  width = 24,
  strokeWidth = 2,
}) => {
  return (
    <svg
      data-testid={id}
      id={id}
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      className={`stroke-${color} ${classes}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        stroke: color,
      }}
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09 9C9.3251 8.33167 9.78915 7.7681 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15848 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17H12.01"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HelpCircle;
